export default "__VITE_ASSET__DBjiKI_O__"